// @flow

import type { Disposable } from 'rgs-knockout';


export const disposePlease = (item: Disposable): void => item && item.dispose && item.dispose();
